import React, { useState, useEffect } from "react";
import AllNodata from "../../../assets/SomethingWentWrongImg.svg";
import { Button } from "antd";
import Select from "antd/lib/select";
import { useDispatch, useSelector } from "react-redux";
import { getPaneIndex, useQuery } from "../../../redux/constants";
import {
  FilterPillsDeepDiveResponse,
  setUpdateDeepDive,
} from "../../../redux/actions/dashboard/Tab1";
import { setDeepDiveWidgetLoaders } from "../../../redux/actions/DeepDive";

const SomethingWrong = ({
  widgetData,
  section_index,
  widget_index,
  isDeepDiveList,
  isPreviewState,
  deepDive,
  widget_id,
  keyName,
  widget_data_index,
}) => {
  let query = useQuery();
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state.Tab1.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);
  const Section = useSelector((state) => state.Section.addSection);
  let index = getPaneIndex(panes, activeKey);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const mentions_object = useSelector(
    (state) => state.WidgetMaker.deep_dive_mentions_object
  );
  const influencers_object = useSelector(
    (state) => state.WidgetMaker.deep_dive_influencers_object
  );
  const widgetLoaders = useSelector((state) => state?.DeepDive?.widgetLoaders);

  let deep_dive_Object = shareTemplateData
    ? shareTemplateData?.deep_dive
    : panes[index]?.deep_dive;

  // console.log("panes data", panes[index]);
  const handleRefresh = () => {
    let pathName = window.location.pathname?.split("/")?.[1];
    if (pathName === "edit-dashboard" || pathName === "create-dashboard") {
      if (widgetData) {
        let updatedSection = [...Section];
        if (section_index >= 0) {
          if (widgetData?.data) {
            updatedSection[section_index].data[widget_index].data = null;
          }
        } else {
          if (widgetData?.data) {
            updatedSection[0].data[widget_index].data = null;
          }
        }
        dispatch({ type: "SET_ADDSECTION", payload: updatedSection });
      }
    } else if (deepDive) {
      let widget_ids = [widget_id];
      // console.log(
      //   "deep_dive_Object",
      //   deep_dive_Object,
      //   "keyName",
      //   keyName,
      //   "final",
      //   deep_dive_Object?.[keyName]?.metadata
      // );
      let common_object;
      if (keyName === "wordcloud") {
        common_object =
          deep_dive_Object.wordcloud?.[widget_data_index]?.metadata;
      } else if (keyName === "category") {
        common_object =
          deep_dive_Object.category?.[widget_data_index]?.metadata;
      } else if (keyName === "source_of_post") {
        common_object =
          deep_dive_Object.source_of_post?.[widget_data_index].metadata;
      } else if (keyName === "influencers") {
        common_object =
          deep_dive_Object.influencers?.[widget_data_index].metadata;
      } else {
        common_object = deep_dive_Object?.[keyName]?.metadata;
      }
      // console.log("common_object", common_object);

      if (shareTemplateData) {
        let updateShareTemplateData = { ...shareTemplateData };
        if (keyName === "wordcloud") {
          updateShareTemplateData.deep_dive.wordcloud[widget_data_index] = null;
        } else if (keyName === "category") {
          updateShareTemplateData.deep_dive.category[widget_data_index] = null;
        } else if (keyName === "source_of_post") {
          updateShareTemplateData.deep_dive.source_of_post[widget_data_index] =
            null;
        } else if (keyName === "influencers") {
          updateShareTemplateData.deep_dive.influencers[widget_data_index] =
            null;
        } else {
          updateShareTemplateData.deep_dive[keyName] = null;
        }
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updateShareTemplateData,
        });
      } else {
        dispatch(
          setUpdateDeepDive(null, panes, index, keyName, widget_data_index)
        );
      }

      dispatch(
        FilterPillsDeepDiveResponse(
          panes,
          index,
          authParams,
          common_object,
          widget_ids,
          query?.get("share_id")
        )
      );
    } else if (shareTemplateData) {
      if (widgetData) {
        let updateShareTemplateData = { ...shareTemplateData };
        if (section_index >= 0) {
          if (widgetData?.graphData) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
        } else {
          if (widgetData?.graphData) {
            updateShareTemplateData.section[0].widgets[widget_index].graphData =
              null;
          }
        }
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updateShareTemplateData,
        });
      }
    } else {
      if (widgetData) {
        let updatePanes = [...panes];
        if (section_index >= 0) {
          if (widgetData?.graphData) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
        } else {
          if (widgetData?.graphData) {
            updatePanes[index].section[0].widgets[widget_index].graphData =
              null;
          }
        }
        dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
      }
    }
  };

  return (
    <>
      {deepDive && keyName === "infoBar" ? (
        <div
          style={{
            height: "140px",
          }}
          className={`d-flex ${
            isPreviewState ? "" : "full_nodata"
          } align-items-center`}
        >
          <div className="w-100 text-center">
            <div className="Nodata_img">
              <img src={AllNodata} alt="no data" style={{ width: "50px" }} />
            </div>
            <div className="portlet__title fontSize-18 font-weight500 w-100">
              Something went wrong
            </div>
            <div className="text_regular-gray">
              An unexpected issue occurred, causing an error or disruption in
              the process. We apologize for any inconvenience this may cause.
            </div>
            <Button
              className="mt-15"
              type="primary"
              onClick={() => handleRefresh()}
            >
              Retry
            </Button>
          </div>
        </div>
      ) : (
        <div
          style={{
            height: isPreviewState
              ? "290px"
              : isDeepDiveList
              ? "260px"
              : "530px",
          }}
          className={`d-flex ${
            isPreviewState ? "" : "full_nodata"
          } align-items-center`}
        >
          <div className="w-100 text-center">
            <div className="Nodata_img mb-15">
              <img src={AllNodata} alt="no data" style={{ width: "100px" }} />
            </div>
            <div className="portlet__title fontSize-18 font-weight500 w-100">
              Something went wrong
            </div>
            <div className="text_regular-gray">
              An unexpected issue occurred, causing an error or disruption in
              the process. <br />
              We apologize for any inconvenience this may cause.
            </div>
            <Button
              className="mt-15"
              type="primary"
              onClick={() => handleRefresh()}
            >
              Retry
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default SomethingWrong;
